module.exports = __webpack_public_path__ + "img/category-arsitektural.7ce94da7.svg";